// Utils / Constants
import { MODEL_PORTFOLIO } from 'NewAngular/constants/core.constants';
// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class ModelPortfoliosService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getModelPortfoliosStatusCollection() {
        const url = this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO_COLLECTION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getModelPortfolioStatus(modelPortfolioId) {
        const urlParams = { modelPortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO_STATUS, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getModelPortfolios(getParams) {
        const url = this.urlsService.MODEL_PORTFOLIOS.COLLECTION;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getModelPortfolioAncestors(modelPortfolioIds) {
        const queryParams = { model_portfolio_ids: modelPortfolioIds.join(',') };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO_ANCESTORS, {}, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getModelPortfolioDescendants(modelPortfolioId) {
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO_DESCENDANTS, {
            modelPortfolioId,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    getTopPortfolioHolders(securityType, securityId, page) {
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.TOP_PORTFOLIO_HOLDERS, {
            securityType,
            securityId,
            page,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    deleteModelPortfolio(modelPortfolioId) {
        const urlParams = { modelPortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO, urlParams);
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    deleteDraftModelPortfolio(modelPortfolioId) {
        const urlParams = { modelPortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.DRAFT_MODEL_PORTFOLIO, urlParams);
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getFixedModelPortfolio(modelPortfolioId) {
        const urlParams = { modelPortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS_FIXED.MODEL_PORTFOLIO, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    putFixedModelPortfolio(modelPortfolioId, modelPortfolioParams, calculate = false) {
        const urlParams = { modelPortfolioId };
        const queryParams = { calculate };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS_FIXED.MODEL_PORTFOLIO, urlParams, queryParams);
        return this.ajaxService.putDataObserveBody(url, modelPortfolioParams);
    }
    putDynamicModelPortfolio(modelPortfolioId, modelPortfolioParams, calculate = false) {
        const urlParams = { modelPortfolioId };
        const queryParams = { calculate };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS_DYNAMIC.MODEL_PORTFOLIO, urlParams, queryParams);
        return this.ajaxService.putDataObserveBody(url, modelPortfolioParams);
    }
    postFixedModelPortfolio(modelPortfolioParams) {
        const formData = new FormData();
        const historicalPerformance = modelPortfolioParams.portfolio.historical_performance;
        formData.append('portfolio', JSON.stringify(modelPortfolioParams.portfolio));
        formData.append('items', JSON.stringify(modelPortfolioParams.items));
        if (historicalPerformance !== null && historicalPerformance.data !== null)
            formData.append('historical_performance', historicalPerformance.data, historicalPerformance.data.name);
        return this.ajaxService.postMultipartFormDataWithObserveBody(this.urlsService.MODEL_PORTFOLIOS_FIXED.COLLECTION, formData);
    }
    postDynamicModelPortfolio(modelPortfolioParams) {
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.MODEL_PORTFOLIOS_DYNAMIC.COLLECTION, modelPortfolioParams);
    }
    getModelPortfolioTemplate(templateId) {
        const urlParams = { templateType: MODEL_PORTFOLIO, templateId };
        const url = this.urlsService.getUrl(this.urlsService.DATA_TEMPLATES.DATA_TEMPLATE, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getDynamicModelPortfolio(modelPortfolioId) {
        const urlParams = { modelPortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS_DYNAMIC.MODEL_PORTFOLIO, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getModelPortfolioTransitionedHoldings(baselinePortfolioId, weightings) {
        const urlParams = { baselinePortfolioId };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO_TRANSITIONED_HOLDINGS, urlParams, {
            weightings,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    resetModelPortfolio(modelPortfolioId) {
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.RESET_MODEL_PORTFOLIO, {
            modelPortfolioId,
        });
        return this.ajaxService.postJsonDataObserveBody(url, {});
    }
    uploadHistoricalPerformanceFile(modelPortfolioId, file) {
        const url = modelPortfolioId !== null
            ? this.getHistoricalPerformanceUploadUrl(modelPortfolioId)
            : this.urlsService.MODEL_PORTFOLIOS.HISTORICAL_PERFORMANCE_VALIDATION;
        const formData = new FormData();
        formData.append('historical_performance', file, file.name);
        return this.ajaxService.postMultipartFormDataWithObserveBody(url, formData);
    }
    getHistoricalPerformanceUploadUrl(modelPortfolioId) {
        const urlParams = { modelPortfolioId };
        return this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.HISTORICAL_PERFORMANCE_UPLOAD, urlParams);
    }
    getHistoricalPerformanceTemplateUrl() {
        return this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.HISTORICAL_PERFORMANCE_TEMPLATE);
    }
    putModelPortfolioAttribute(modelPortfolioId, attributes) {
        const urlParams = { modelPortfolioId };
        const attributeParams = { attributes };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.MODEL_PORTFOLIO_ATTRIBUTE, urlParams);
        return this.ajaxService.putDataObserveBody(url, attributeParams);
    }
    getTransitionAnalysisResults(params) {
        const urlParams = {
            transitionStrategy: params.transition_strategy,
            initialPortfolioId: params.initial_portfolio_id,
        };
        const url = this.urlsService.getUrl(this.urlsService.MODEL_PORTFOLIOS.EXECUTE_TRANSITION_ANALYSIS, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, params);
    }
    exportTransitionAnalysisPDF(params) {
        return this.ajaxService.postJsonDataWithBlobResponseObserveResponse(this.urlsService.MODEL_PORTFOLIOS.EXPORT_TRANSITION_ANALYSIS, params);
    }
    archiveTransitionAnalysis(params) {
        return this.ajaxService.postJsonDataObserveBody(this.urlsService.MODEL_PORTFOLIOS.ARCHIVE_TRANSITION_ANALYSIS, params);
    }
    getTransitionAnalysisList() {
        const url = this.urlsService.MODEL_PORTFOLIOS.TRANSITION_ANALYSIS_LIST;
        return this.ajaxService.getDataObserveBody(url);
    }
}
ModelPortfoliosService.ɵfac = function ModelPortfoliosService_Factory(t) { return new (t || ModelPortfoliosService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
ModelPortfoliosService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ModelPortfoliosService, factory: ModelPortfoliosService.ɵfac, providedIn: 'root' });
